import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import topic from 'dojo/topic';

import '../../moreCore/UI/GenericDialog/GenericDialog';
import { PrivateAppointmentEditor, PrivateAppointmentTypes, PAclassNames } from "../_loadingHelpers/PrivateAppointment";
import _EntityViewMixin from '../../moreCore/UI/EntityBased/EntityView/EntityView';
import _WidgetBase from 'dijit/_WidgetBase';
class PrivateAppointmentView extends compose(_EntityViewMixin<PrivateAppointmentTypes.PrivateAppointment_Base>) {

    private _loadingRequest: dojo.request.Promise<any> = null;
    private editingVisible: boolean = false;

    private actionNode: HTMLElement;
    private contentNode: HTMLElement;
    private btnDelete: HTMLButtonElement;

    private _additionalRequestParams: Object = null;

    /**
    * 
    * @param entityId
    * @param label
    * @param additionalParams
    * @param tabContainerName
    * @param contextName Beliebiger Kontextname, der im Backend eine Differenzierung zum Zweck der Ansicht zulässt
    */


    setup(entityId: string,
        label: string,
        additionalParams?: Object,
        contextName?: string,
        tabContainerName?: string) {

        if (additionalParams) {
            this.config.additionalRequestParams = lang.clone(additionalParams);
        }

        if (contextName) this.setContextName(contextName);

        this.showAsDlg(entityId, label, tabContainerName);
    }

    onShow() {
        this.handleAdditionalButtons();
    }

    private handleAdditionalButtons() {

    }

    protected onRequestEditor(entityID: string, entity): MdsLax<InstanceType<typeof _WidgetBase>> {

        let editor = new PrivateAppointmentEditor();

        //editor.startup();
        if (!this.isEmbeddedInTab) this.tryMoveToTab(false);

        if (this.isEmbeddedInTab) {
            this.createNewTabbedContent({
                widget: editor,
                enableClosing: true,
                label: this.title,
                name: this.internalName,
                coloration: null,
                groupLabel: this.title,
                iconclass: "fas fa-edit",
                sidebarEntryName: this.internalName,
                targetContainerName: this.getTabContainerName()
            }, true, true);
        }

        editor.loadEntityById(this.entityID);

        editor.on("saved", lang.hitch(this, this._onEditorSaved));
        editor.on("closed", lang.hitch(this, this._onClosing));

        return editor;
    }

    afterDelete() {
        topic.publish("PrivateAppointment/Deleted", this.entity); //TODO
    }

    private _onDeletePrivateAppointmentError(error: more.requestErrorMessage) {
        this.StandbyStop();

        alert(error.Message);
    }


    private _onEditorSaved(response) {
        this.emit("saved", response);
        //this.reload();
    }

    postCreate(): void {

        this.config = {
            entityClassname: PAclassNames.private_appointment,
            labelProperty: "description",
            entityClassPrintname: this.translate("General_Label_PrivateAppointment"),
            cloneOptions: {
                userroleClone: "PrivateAppointment_Handle",
                featurePathClone: "PrivateAppointment/Clone",
            },
            editOptions: {
                userroleEdit: "PrivateAppointment_Handle",
                featurePathEdit: null,//"EvBooking/EvBookingEditor",
                onChangedEventName: "change",
                onDeletedEventName: "deleted",
                onSavedEventName: "saved"
            },
            deleteOptions: {
                userroleDelete: "PrivateAppointment_Handle",
                featurePathDelete: null,
            }
            
            
            
            //requestDataFunctionname:"Webtool_API_Appointments__GetEntityData"
        }
        super.postCreate.apply(this, arguments as any);


        //    this.checkPrivileges();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PrivateAppointmentView);